<template>
  <EstimatorForm :meterpoint="meterpoint" :mode="mode" />
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import EstimatorForm from "./EstimatorForm.vue"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"
  import { EstimatorUiMode } from "./estimatorHelper"

  /**
   * "Two reads to an annual consumption figure", the shared entry point for the
   * one question the renewals usage calculator already asked. It is the tab
   * content there and the third tab of the Estimate Reads modal, so both give
   * the same answer from the same service (FR-08 / US-07).
   */
  export default defineComponent({
    components: { EstimatorForm },
    props: {
      meterpoint: {
        type: Object as PropType<IMeterpoint>,
        required: true,
      },
    },
    data() {
      return {
        mode: EstimatorUiMode.EacAqFromTwoReads,
      }
    },
  })
</script>
